import { UserService } from './user.service';
import { Injectable } from '@angular/core';
import { GroupedListItem } from '@atpco/hub-ui';
import { FeatureFlagsService } from './feature-flags.service';
import { Partner } from './partner';

@Injectable({ providedIn: 'root' })
export class UtilityLinksService {

  galleryLink: GroupedListItem = {
    group: {
      name: 'Gallery',
      id: '/gallery/media'
    },
  }

  bundlesLink: GroupedListItem = {
    group: {
      name: 'Bundles',
      id: '/bundles',
    },
  };

  seatsLink: GroupedListItem = {
    group: {
      name: 'Seats',
      id: 'seats',
    },
    listItems: [
    {
      name: 'Seat Characteristics',
      id: '/seats/seat-characteristics',
    }, 
    {
      name: 'Seat Characteristics Management',
      id: '/seats/seat-characteristics-management',
    },]
  };

  listsLink: GroupedListItem = {
    group: {
      name: 'Lists',
      id: 'lists-airport',
    },
    listItems: [
      {
        name: 'Aircraft',
        id: '/lists/aircraft',
      },
      {
        name: 'Airports',
        id: '/lists/airport',
      },
      {
        name: 'Countries',
        id: '/lists/country',
      },
      {
        name: 'Origin & destination',
        id: '/lists/origin_and_destination',
      },
      {
        name: 'Subfleets',
        id: '/lists/subfleet',
      },
      {
        name: 'Terminals',
        id: '/lists/terminal',
      },
      {
        name: 'Inflight Amenities',
        id: '/lists/amenity',
      }]
  };
  settingsLink: GroupedListItem = {
    group: {
      name: 'Settings',
      id: '/settings/fare_types',
    },
    listItems: [{
      name: 'Fare brands',
      id: '/settings/fare_types',
    },
    {
      name: 'Categories',
      id: '/settings/categories',
    },
    {
      name: 'Team',
      id: '/settings/users',
    },
    ]
  };

  constructor(private userService: UserService, private featureFlagsService: FeatureFlagsService) { }

  getLinks(user: any, partner: Partner, isUpa: boolean): GroupedListItem[] {
    const links: GroupedListItem[] = [];

    if (isUpa) {
      if (this.userService.getPermissionDisplayGalleryLinks(user)) {
        links.push(this.galleryLink);
      }
      if (this.featureFlagsService.getFeatureFlag('bundles') && this.userService.getPermissionDisplayBundlesLinks(user)) {
        links.push(this.bundlesLink);
      }
      if (this.userService.getPermissionDisplayListsLinks(user)) {
        links.push(this.listsLink);
      }
    }
    if (this.userService.getPermissionDisplaySettingsLinks(user)) {
      links.push(this.settingsLink);
    }
    return links;
  }
}
